module.exports = __webpack_public_path__ + "static/media/wallfinishes_material_60y_y.fc7eb823.csv";